import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import('@/pages/index/index.vue'),
  },
  {
    path: "/onepage",
    component: () => import('@/pages/index/onepage.vue'),
  },
  {
    path: "/aboutus",
    component: () => import('@/pages/aboutus.vue'),
  },
  {
    path: "/services",
    component: () => import('@/pages/services.vue'),
  },
  {
    path: "/service-detail",
    component: () => import('@/pages/service-detail.vue'),
  },
  {
    path: "/pricing",
    component: () => import('@/pages/pricing.vue'),
  },
  {
    path:"/team",
    component:() => import('@/pages/team.vue')
  },
  {
    path:"/testimonial",
    component:() => import('@/pages/testimonial.vue')
  },
  {
    path:"/faqs",
    component:() => import('@/pages/faqs.vue')
  },
  {
    path:"/blogs",
    component:() => import('@/pages/blogs.vue')
  },
  {
    path:"/blog-sidebar",
    component:() => import('@/pages/blog-sidebar.vue')
  },
  {
    path:"/blog-detail",
    component:() => import('@/pages/blog-detail.vue')
  },
  {
    path:"/blog-detail/:id",
    component:() => import('@/pages/blog-detail.vue')
  },
  {
    path:"/login",
    component:() => import('@/pages/auth/login')
  },
  {
    path:"/signup",
    component:() => import('@/pages/auth/signup')
  },
  {
    path:"/reset-password",
    component:() => import('@/pages/auth/reset-password')
  },
  {
    path:"/lock-screen",
    component:() => import('@/pages/auth/lock-screen')
  },
  {
    path:"/terms",
    component:() => import('@/pages/terms')
  },
  {
    path:"/privacy",
    component:() => import('@/pages/privacy')
  },
  {
    path:"/comingsoon",
    component:() => import('@/pages/special/comingsoon')
  },
  {
    path:"/maintenance",
    component:() => import('@/pages/special/maintenance')
  },
  {
    path:"/error",
    component:() => import('@/pages/special/error')
  },
  {
    path:"/contactus",
    component:() => import('@/pages/contactus')
  },
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;